import { render, staticRenderFns } from "./PasswordChange.vue?vue&type=template&id=af6a8a3a&scoped=true"
import script from "./PasswordChange.vue?vue&type=script&lang=ts"
export * from "./PasswordChange.vue?vue&type=script&lang=ts"
import style0 from "./PasswordChange.vue?vue&type=style&index=0&id=af6a8a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6a8a3a",
  null
  
)

export default component.exports